export default __webpack_public_path__ + "static/media/admin.136c28d3.svg";